import { v4 as uuidv4 } from 'uuid';
import Cookies from 'js-cookie';

/**
 * Name of the cookie
 */
const nameOfTheCookie = 'iqos_visitor_id';

/**
 * Get cookie by name
 */
const getCookieByName = (name: string) => {
  const matches = document.cookie.match(
    new RegExp(
      '(?:^|; )' +
        name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') +
        '=([^;]*)'
    )
  );

  return !!matches ? decodeURIComponent(matches[1]) : undefined;
};

const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
  var R = 6371; // Radius of the earth in km
  var dLat = deg2rad(lat2 - lat1); // deg2rad below
  var dLon = deg2rad(lon2 - lon1);
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c; // Distance in km
  return d;
};
const deg2rad = deg => {
  return deg * (Math.PI / 180);
};

const setCookieByName = (name: string, value: string) => {
  Cookies.set(name, value, { path: '', domain: '.zyn.com.ua' });

  return true;
};

/**
 * Get unique cookie to send to API
 */
const generateUniqueCookie = () => getCookieByName(nameOfTheCookie) || uuidv4();

export {
  generateUniqueCookie,
  getCookieByName,
  setCookieByName,
  getDistanceFromLatLonInKm
};
